import axios from 'axios';
import history from './history';
// import { toast } from 'react-toastify';

export const baseURL = process.env.REACT_APP_BASE_URL;
export const baseURLWeb = process.env.REACT_APP_BASE_URL_WEB;

export const http = async (params) => {
  try {
    params.showMessage = params.showMessage !== undefined ? params.showMessage : true;
    let auth = JSON.parse(localStorage.getItem('kominfo-psre'));
    let config = {
      method:params.method ? params.method : 'GET',
      baseURL:baseURL,
      url:params.path ? params.path : '',
      data:params.data ? params.data : {},
      headers:{
        'Authorization': auth || params.token ? auth.token || params.token : '',
        'Content-Type': params.content_type ? params.content_type :'application/json'
      }
    };
    // console.log('params axios ', config)
    let result = await axios(config);
    if (result.data.message === 'Token tidak valid') {
      let message = 'Token anda sudah tidak berlaku, Silahkan Login Lagi!';
      // if (localStorage.getItem('kominfo-psre')) toast.error(message);
      if (localStorage.getItem('kominfo-psre')) alert(message);
      localStorage.removeItem('kominfo-psre');
      history.push('/login');
      return {data:{status:false,code:500,message:message,data:[]}}
    } else {
      if (params.showMessage === true){        
        // if (result.data.status) toast.info(result.data.message);
        // else toast.error(result.data.message);        
        if (result.data.status) alert(result.data.message);
        else alert(result.data.message);        
      }
      return result;
    }        
  } catch (err) {
    // console.log('asdfasd   result ==> ', err);
    let message = 'Tidak dapat terkoneksi dengan server!';
    // localStorage.removeItem('kominfo-psre');
    // toast.error(message)
    // alert(message)
    return {data:{status:false,code:500,message:message,data:[]}}
  }
}
